import { useReduxState } from 'hooks';
import { SiteSettingsForm } from 'components/admin/settings';
import { Checkbox, FormGroup } from 'components/common/form';

const CertificatesSettings = () => {
  const { messages, serverConfig } = useReduxState();

  const {
    certificatesEnableCourseBackground,
    certificatesEnableSelection,
    certificatesEnableSelectionOnCreate
  } = serverConfig;

  const initialValues = {
    certificatesEnableCourseBackground,
    certificatesEnableSelection,
    certificatesEnableSelectionOnCreate
  };

  return (
    <div className="settings">
      <SiteSettingsForm
        initialValues={initialValues}
        title={'Certificates settings'}
      >
        {(formState) => (
          <div>
            <FormGroup label={'Course background image'}>
              <Checkbox
                field="certificatesEnableCourseBackground"
                id="certificates-enable-course-background"
                label={messages.siteSettingsEnableCourseBackgroundImage}
              />
            </FormGroup>

            <FormGroup label={'Template selection'}>
              <Checkbox
                field="certificatesEnableSelection"
                id="certificates-enable-selection"
                label={messages.siteSettingsEnableTemplateSelection}
              />

              <Checkbox
                disabled={!formState.values.certificatesEnableSelection}
                field="certificatesEnableSelectionOnCreate"
                id="certificates-enable-selection-on-create"
                label={messages.siteSettingsEnableTemplateSelectionOnCreate}
                style={{ marginTop: 5 }}
              />
            </FormGroup>
          </div>
        )}
      </SiteSettingsForm>
    </div>
  );
};

export default CertificatesSettings;
